import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FilterPanel } from "./Helper/FilterPanel";
import { FormatMoney } from "../../../Helpers/FormatNumber";

import {
  ClavesCategoriasScorecard,
  EtiquetasCategoriasScorecard,
  OpcionesCategoriasScorecard,

} from "../../../Arrays/CategoriasScorecardArray";

export const DashScorecardGerenteAsesorTable = ({ datos, boxstate }) => {
  const history = useHistory();

  // Etiquetas, claves y opciones del filtro salen del catálogo compartido
  // src/arrays/CategoriasScorecardArray.js (incluye Refacciones y Visitas).
  // Agregar una línea nueva sólo requiere agregarla en ese arreglo.
  const categoriasLabel = EtiquetasCategoriasScorecard;

  const [filters, setFilters] = useState({
    categorias: "Tractores", // 🔥 solo una categoría
  });

  const filtersConfig = [
    {
      key: "categorias",
      label: "Categorías",
      // icon: "📊",
      options: OpcionesCategoriasScorecard,
    },
  ];

  const categoriaActiva = filters.categorias;

  //Expandible
  const [openSucursales, setOpenSucursales] = useState({});

  // Función para alternar la apertura de la sucursal
  const toggleSucursal = (sucursal) => {
    setOpenSucursales((prev) => ({
      ...prev,
      [sucursal]: !prev[sucursal], // cambia true/false
    }));
  };

  const formatPorcentaje = (real, objetivo) => {
    const r = Number(real) || 0;
    const c = Number(objetivo) || 0;

    if (r === 0 && c === 0) {
      return 0;
    }

    if (c === 0) {
      return 100;
    }

    const porcentaje = ((r / c) * 100).toFixed(2);

    // return Math.min(porcentaje, 100);
    return porcentaje;
  };

  const indicadorPorcentaje = (value) => {

    if (value > 85) {
      return "verde"
    }
    else if (value > 65) {
      return "amarillo"
    }
    else {
      return "rojo"
    }
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  // Normaliza a número cualquier valor del endpoint (undefined, null o texto).
  // Evita que una línea sin dato en algún asesor propague NaN a los totales
  // por ADR/Sucursal/Grupo o a la resta Real - Comparativo.
  const valorNumerico = (valor) => Number(valor) || 0;

  // Refacciones viene en pesos (no en unidades). Formatea con FormatMoney
  // solo cuando esa categoría está seleccionada; el resto de categorías
  // (unidades) se muestran igual que antes.
  const formatCelda = (valor) => {
    const numero = valorNumerico(valor);
    return categoriaActiva === "Refacciones" ? FormatMoney(numero,0) : numero;
  };



  const onDetalle = (idasesor, asesor) => {
    const boxstateToSave = {
      ...boxstate,
      pv: {
        ...boxstate.pv,
        sucursal: Array.isArray(boxstate.pv.sucursal) && boxstate.pv.sucursal.length === 1
          ? [{ ...boxstate.pv.sucursal[0], sucursal: capitalizeWords(boxstate.pv.sucursal[0].sucursal) }]
          : [],  // Si hay 0 o más de 1 sucursal, se guarda como vacío
        vendedor: [
          {
            idvendedor: idasesor,
            vendedor: asesor
          }
        ]
      }
    };

    localStorage.setItem('DatosFiltro', JSON.stringify(boxstateToSave));

    history.push({
      pathname: "/Ventas/DashboardScorecardVendedorDetalle",
      state: {
        boxInicial: boxstate,
        idasesor,
        asesor,
      },
    });
  };

  // console.log(datos)

  const agrupados = datos.reduce((acc, item) => {
    // 1️⃣ Si el ADR no existe en el acumulador, lo inicializamos
    if (!acc[item.adr]) {
      acc[item.adr] = {
        adr: item.adr,
        totales: {},
        sucursales: {},
      };
    }

    // 2️⃣ Si la sucursal no existe en el ADR, la creamos
    if (!acc[item.adr].sucursales[item.sucursal]) {
      acc[item.adr].sucursales[item.sucursal] = {
        sucursal: item.sucursal,
        totales: {},
        asesores: [],
      };
    }

    // 3️⃣ Agregar el asesor a la sucursal
    acc[item.adr].sucursales[item.sucursal].asesores.push(item);

    // 4️⃣ Sumar los valores de objetivos y reales por categoría en ADR y Sucursal
    //    (las claves incluyen Refacciones y Visitas desde el catálogo).
    ClavesCategoriasScorecard.forEach((categoria) => {
      // Sumar a nivel ADR
      acc[item.adr].totales[`objetivo_${categoria}`] =
        valorNumerico(acc[item.adr].totales[`objetivo_${categoria}`]) +
        valorNumerico(item[`objetivo_${categoria}`]);
      acc[item.adr].totales[`real_${categoria}`] =
        valorNumerico(acc[item.adr].totales[`real_${categoria}`]) +
        valorNumerico(item[`real_${categoria}`]);
      acc[item.adr].totales[`comp_${categoria}`] =
        valorNumerico(acc[item.adr].totales[`comp_${categoria}`]) +
        valorNumerico(item[`comp_${categoria}`]);

      // Sumar a nivel Sucursal
      acc[item.adr].sucursales[item.sucursal].totales[`objetivo_${categoria}`] =
        valorNumerico(
          acc[item.adr].sucursales[item.sucursal].totales[
          `objetivo_${categoria}`
          ]
        ) + valorNumerico(item[`objetivo_${categoria}`]);
      acc[item.adr].sucursales[item.sucursal].totales[`real_${categoria}`] =
        valorNumerico(
          acc[item.adr].sucursales[item.sucursal].totales[`real_${categoria}`]
        ) + valorNumerico(item[`real_${categoria}`]);
      acc[item.adr].sucursales[item.sucursal].totales[`comp_${categoria}`] =
        valorNumerico(
          acc[item.adr].sucursales[item.sucursal].totales[`comp_${categoria}`]
        ) + valorNumerico(item[`comp_${categoria}`]);
    });

    return acc;
  }, {});

  const grupoTotales = datos.reduce((acc, item) => {
    ClavesCategoriasScorecard.forEach((categoria) => {
      acc[`objetivo_${categoria}`] =
        valorNumerico(acc[`objetivo_${categoria}`]) +
        valorNumerico(item[`objetivo_${categoria}`]);
      acc[`real_${categoria}`] =
        valorNumerico(acc[`real_${categoria}`]) +
        valorNumerico(item[`real_${categoria}`]);
      acc[`comp_${categoria}`] =
        valorNumerico(acc[`comp_${categoria}`]) +
        valorNumerico(item[`comp_${categoria}`]);
    });
    return acc;
  }, {});

  const calcularPorcentaje = (real, comp) => {
    const r = Number(real) || 0;
    const c = Number(comp) || 0;

    if (c === 0) {
      return r === 0 ? 0 : 100;
    }

    const resultado = (r * 100) / c;

    return Number.isFinite(resultado) ? resultado : 0;
  };

  // console.log(datosAgrupados)

  return (
    <div className="dash-tabla-score-card-gerente-asesor-table-container-main">
      {/* FILTRO */}
      <div className="dash-tabla-score-card-gerente-asesor-table-filtro-container">
        <FilterPanel
          title=""
          filtersConfig={filtersConfig}
          filters={filters}
          setFilters={setFilters}
        />
      </div>
      <div style={{ flex: 1 }}>
        <div className="dash-tabla-score-card-gerente-asesor-table scroll-4">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th></th>
                <th></th>

                {/* {filters.categorias.map((categoria) => (
                                    <th key={categoria} colSpan={3}>
                                        <div>{categoriasLabel[categoria]}</div>
                                    </th>
                                ))} */}

                {categoriaActiva && (
                  <th colSpan={boxstate.mostrar_comparativo === "S" ? 7 : 4}>
                    <div>{categoriasLabel[categoriaActiva]}</div>
                  </th>
                )}
              </tr>
              <tr>
                <th colSpan={2}>
                  <div>Asesor</div>
                </th>

                {/* {filters.categorias.map((categoria) => (
                                    <React.Fragment key={categoria}>
                                        <th><div>Objetivo</div></th>
                                        <th><div>Real</div></th>
                                        <th><div>Alcance</div></th>
                                    </React.Fragment>
                                ))} */}

                {categoriaActiva && (
                  <>
                    <th>
                      <div>Objetivo</div>
                    </th>
                    <th>
                      <div>Real</div>
                    </th>
                    <th>
                      <div>Alcance</div>
                    </th>
                    <th></th>

                    {boxstate.mostrar_comparativo === "S" && (
                      <>
                        <th>
                          <div>{boxstate.comparativa}</div>
                        </th>
                        <th>
                          <div>Diferencia</div>
                        </th>
                        <th>
                          <div>Alcance</div>
                        </th>
                      </>
                    )}
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {/* FILA GRUPO TOTAL */}
              <tr className="row-grupo-total">
                <td colSpan={2} className="celda-adr asesor-sticky">
                  <strong>GRUPO</strong>
                </td>
                {categoriaActiva && (
                  <>
                    <td>
                      <strong>
                        {formatCelda(grupoTotales[`objetivo_${categoriaActiva}`])}
                      </strong>
                    </td>
                    <td>
                      <strong>{formatCelda(grupoTotales[`real_${categoriaActiva}`])}</strong>
                    </td>
                    <td>
                      <strong>
                        {formatPorcentaje(
                          grupoTotales[`real_${categoriaActiva}`],
                          grupoTotales[`objetivo_${categoriaActiva}`],
                        )}
                        %
                      </strong>
                    </td>
                    <td className="row-indicador">
                      <span
                        className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(grupoTotales[`real_${categoriaActiva}`], grupoTotales[`objetivo_${categoriaActiva}`],))}`}
                      ></span>
                    </td>

                    {boxstate.mostrar_comparativo === "S" && (
                      <>
                        <td>{formatCelda(grupoTotales[`comp_${categoriaActiva}`])}</td>
                        <td>
                          {formatCelda(
                            grupoTotales[`real_${categoriaActiva}`] -
                            grupoTotales[`comp_${categoriaActiva}`]
                          )}
                        </td>
                        <td>
                          {calcularPorcentaje(
                            grupoTotales[`real_${categoriaActiva}`],
                            grupoTotales[`comp_${categoriaActiva}`],
                          ).toFixed(0)} %
                        </td>
                      </>
                    )}
                  </>
                )}
              </tr>

              {Object.values(agrupados).map((adrData) => (
                <React.Fragment key={adrData.adr}>
                  {/*FILA ADR*/}
                  <tr className="row-adr">
                    <td colSpan={2} className="celda-adr asesor-sticky">
                      <strong>{adrData.adr}</strong>
                    </td>
                    {categoriaActiva && (
                      <>
                        <td>
                          <strong>
                            {formatCelda(adrData.totales[`objetivo_${categoriaActiva}`])}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {formatCelda(adrData.totales[`real_${categoriaActiva}`])}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            {formatPorcentaje(
                              adrData.totales[`real_${categoriaActiva}`],
                              adrData.totales[`objetivo_${categoriaActiva}`],
                            )}
                            %
                          </strong>
                        </td>
                        <td className="row-indicador">
                          <span
                            className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(adrData.totales[`real_${categoriaActiva}`], adrData.totales[`objetivo_${categoriaActiva}`],))}`}
                          ></span>
                        </td>
                        {boxstate.mostrar_comparativo === "S" && (
                          <>
                            <td>
                              {formatCelda(adrData.totales[`comp_${categoriaActiva}`])}
                            </td>
                            <td>
                              {formatCelda(
                                adrData.totales[`real_${categoriaActiva}`] -
                                adrData.totales[`comp_${categoriaActiva}`]
                              )}
                            </td>
                            <td>
                              {calcularPorcentaje(
                                adrData.totales[`real_${categoriaActiva}`],
                                adrData.totales[`comp_${categoriaActiva}`],
                              ).toFixed(0)} %
                            </td>
                          </>
                        )}
                      </>
                    )}
                  </tr>

                  {/*FILAS SUCURSALES*/}
                  {Object.values(adrData.sucursales).map((sucursalData) => (
                    <React.Fragment key={sucursalData.sucursal}>
                      <tr
                        className="row-sucursal"
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          colSpan={2}
                          className="asesor-sticky"
                          style={{ paddingLeft: "20px" }}
                          onClick={() => toggleSucursal(sucursalData.sucursal)}
                        >
                          {/* Flecha */}
                          <span
                            style={{ marginRight: "8px", fontSize: "10px" }}
                          >
                            {openSucursales[sucursalData.sucursal] ? "▼" : "▶"}
                          </span>
                          <strong>{sucursalData.sucursal}</strong>
                        </td>
                        {categoriaActiva && (
                          <>
                            <td>
                              {formatCelda(
                                sucursalData.totales[
                                `objetivo_${categoriaActiva}`
                                ]
                              )}
                            </td>
                            <td>
                              {formatCelda(sucursalData.totales[`real_${categoriaActiva}`])}
                            </td>
                            <td>
                              {formatPorcentaje(
                                sucursalData.totales[`real_${categoriaActiva}`],
                                sucursalData.totales[
                                `objetivo_${categoriaActiva}`
                                ],
                              )}
                              %
                            </td>
                            <td className="row-indicador">
                              <span
                                className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(sucursalData.totales[`real_${categoriaActiva}`], sucursalData.totales[`objetivo_${categoriaActiva}`],))}`}
                              ></span>
                            </td>
                            {boxstate.mostrar_comparativo === "S" && (
                              <>
                                <td>
                                  {formatCelda(
                                    sucursalData.totales[
                                    `comp_${categoriaActiva}`
                                    ]
                                  )}
                                </td>
                                <td>
                                  {formatCelda(
                                    sucursalData.totales[
                                      `real_${categoriaActiva}`
                                    ] -
                                    sucursalData.totales[
                                    `comp_${categoriaActiva}`
                                    ]
                                  )}
                                </td>
                                <td>
                                  {calcularPorcentaje(
                                    sucursalData.totales[
                                    `real_${categoriaActiva}`
                                    ],
                                    sucursalData.totales[
                                    `comp_${categoriaActiva}`
                                    ],
                                  ).toFixed(0)} %
                                </td>
                              </>
                            )}
                          </>
                        )}
                      </tr>

                      {/*FILAS ASESORES*/}
                      {openSucursales[sucursalData.sucursal] &&
                        sucursalData.asesores.map((asesor) => (
                          <tr
                            key={asesor.asesor}
                            className="row-asesor"
                            onClick={() =>
                              onDetalle(asesor.idasesor, asesor.asesor)
                            }
                          >
                            <td
                              colSpan={2}
                              className="asesor-sticky"
                              style={{ paddingLeft: "40px" }}
                            >
                              {asesor.asesor}
                            </td>

                            {categoriaActiva && (
                              <>
                                <td>
                                  {formatCelda(
                                    asesor[`objetivo_${categoriaActiva}`],
                                  )}
                                </td>
                                <td>
                                  {formatCelda(
                                    asesor[`real_${categoriaActiva}`],
                                  )}
                                </td>
                                <td>
                                  {formatPorcentaje(
                                    asesor[`real_${categoriaActiva}`],
                                    asesor[`objetivo_${categoriaActiva}`],
                                  )}
                                  %
                                </td>
                                <td className="row-indicador">
                                  <span
                                    className={`indicador-circulo ${indicadorPorcentaje(formatPorcentaje(asesor[`real_${categoriaActiva}`], asesor[`objetivo_${categoriaActiva}`],))}`}
                                  ></span>
                                </td>
                                {boxstate.mostrar_comparativo === "S" && (
                                  <>
                                    <td>
                                      {formatCelda(
                                        asesor[`comp_${categoriaActiva}`],
                                      )}
                                    </td>
                                    <td>
                                      {formatCelda(
                                        valorNumerico(
                                          asesor[`real_${categoriaActiva}`],
                                        ) -
                                        valorNumerico(
                                          asesor[`comp_${categoriaActiva}`],
                                        )
                                      )}
                                    </td>
                                    <td>
                                      {calcularPorcentaje(
                                        asesor[`real_${categoriaActiva}`],
                                        asesor[`comp_${categoriaActiva}`],
                                      ).toFixed(0)} %
                                    </td>
                                  </>
                                )}
                              </>
                            )}
                          </tr>
                        ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
